import {useEffect} from 'react';
import ClassList from 'class-list';
import {connect} from 'react-redux';

import {togglePanel} from '../../actionCreators';

import Button from './Button';

const ControlsArea = document.querySelector('.controls-area');
const ControlsAreaClassList = ClassList(ControlsArea);

const PanelOpenClassName = 'panel-open';

const Wrapper = ({panelOpen, ...props}) => {
    useEffect(
        () => {
            if (panelOpen) {
                ControlsAreaClassList.add(PanelOpenClassName);
            } else {
                ControlsAreaClassList.remove(PanelOpenClassName);
            }
        },
        [panelOpen],
    );

    return <Button {...props} />;
};

const mapStateToProps = ({panelOpen}) => ({panelOpen});

const mapDispatchToProps = dispatch => ({
    onClick: () => dispatch(togglePanel),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
